// extracted by mini-css-extract-plugin
export default {"messageHolder":"Message_messageHolder__3pvns","select":"Message_select__C4Ed8"};